function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.59998 16.6679H1.19301V5.6585H4.59998V16.6679ZM2.89467 4.15672C1.80546 4.15672 0.921631 3.25123 0.921631 2.15803C0.921631 1.06482 1.80546 0.177734 2.89467 0.177734C3.98387 0.177734 4.8677 1.06482 4.8677 2.15803C4.8677 3.25123 3.98387 4.15672 2.89467 4.15672ZM17.3514 16.6679H13.9517V11.3086C13.9517 10.0313 13.9261 8.39336 12.1804 8.39336C10.4091 8.39336 10.1377 9.78104 10.1377 11.2166V16.6679H6.73438V5.6585H10.002V7.16028H10.0497C10.5044 6.29529 11.6156 5.38244 13.2733 5.38244C16.7206 5.38244 17.355 7.66088 17.355 10.6203V16.6679H17.3514Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linkedin.3318b70c.svg";
export { SvgComponent as ReactComponent };